// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".working-card .b-time-minutes output.border-bottom.border-top {\n  border-bottom: none !important;\n  border-top: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
